import { render, staticRenderFns } from "./PaymentRoutingTable.vue?vue&type=template&id=55a37390"
import script from "./PaymentRoutingTable.vue?vue&type=script&lang=js"
export * from "./PaymentRoutingTable.vue?vue&type=script&lang=js"
import style0 from "./PaymentRoutingTable.vue?vue&type=style&index=0&id=55a37390&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports